import type { Project, ProjectLink } from "@akhshy/types";
import { HATS, STACK, STACK_GROUPS } from "./profile.ts";

export const SEARCH_ITEM_ID = "search";

export type DeskItem =
  | { kind: "search"; id: typeof SEARCH_ITEM_ID; title: string }
  | { kind: "hat"; id: string; title: string; body: string }
  | { kind: "project"; id: string; title: string; meta: string; body: string; links: ProjectLink[] }
  | { kind: "stack"; id: string; title: string; list: string[] };

export const DESK_KIND_LABEL: Record<DeskItem["kind"], string> = {
  search: "Search",
  hat: "Hat I wear",
  project: "Project",
  stack: "Stack",
};

function hatItems(): DeskItem[] {
  return HATS.map((h) => ({ kind: "hat", id: `hat-${h.id}`, title: h.label, body: h.line }));
}

function projectItems(projects: Project[]): DeskItem[] {
  return projects.map((p) => ({
    kind: "project",
    id: `project-${p.id}`,
    title: p.name,
    meta: p.tag,
    body: p.description,
    links: p.links,
  }));
}

function stackItems(): DeskItem[] {
  return STACK_GROUPS.map((group) => ({
    group,
    list: STACK.filter((s) => s.group === group.id).map((s) => s.name),
  }))
    .filter(({ list }) => list.length > 0)
    .map(({ group, list }) => ({ kind: "stack", id: `stack-${group.id}`, title: group.label, list }));
}

const SEARCH_ITEM: DeskItem = { kind: "search", id: SEARCH_ITEM_ID, title: "Looking for something?" };

/** Everything pinned to the home desk, in tab order: search, hats, projects, then stack. */
export function buildDeskItems(projects: Project[]): DeskItem[] {
  return [SEARCH_ITEM, ...hatItems(), ...projectItems(projects), ...stackItems()];
}
